import { render, staticRenderFns } from "./AppstauberWidget.vue?vue&type=template&id=73f4befa&scoped=true"
import script from "./AppstauberWidget.vue?vue&type=script&lang=js"
export * from "./AppstauberWidget.vue?vue&type=script&lang=js"
import style0 from "./AppstauberWidget.vue?vue&type=style&index=0&id=73f4befa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4befa",
  null
  
)

export default component.exports